import { useRecoilValue } from 'recoil'
import { accountTotalProfitsState } from '../../states/profit-shares-state'
import { StatsItem } from '../stats/stats-item'
import { useAccountContext } from '../../contexts/account-context'
import { CurrencyOperations } from '../../utils/currency'

interface Props {}

export const TotalProfitsStat = (props: Props) => {
  const accountId = useAccountContext()
  const profitsTotal = useRecoilValue(accountTotalProfitsState(accountId || ''))

  const calculated = CurrencyOperations.getValueIn('BUSD', 'CZK', profitsTotal)
  return <StatsItem title={'Profits Total'} value={calculated} prefix={'CZK'} />
}